<template>
  <div class="max-w-4xl mx-auto mt-8 bg-white p-6 rounded-xl shadow-md">
    <div class="flex items-start justify-between mb-6">
      <div>
        <h2 class="text-2xl font-bold text-gray-800 flex items-center gap-2">
          Teams
          <BaseInfoIcon :text="ERKLAERUNG.teamListe" label="Teams" />
        </h2>
        <p class="text-gray-600 text-sm">Manage team records.</p>
      </div>
      <router-link to="/teams/create">
        <BaseButton class="bg-green-500 hover:bg-green-600">
          Create Team
        </BaseButton>
      </router-link>
    </div>

    <ul class="divide-y divide-gray-200">
      <li v-for="team in teams" :key="team.id" class="py-4">
        <div class="flex items-center justify-between">
          <span class="text-lg font-medium text-gray-900">{{ team.name }}</span>
          <div class="flex items-center space-x-2">
            <BaseButton
              class="p-2 rounded-full"
              variant="edit"
              tooltip="Edit team"
              @click="$router.push(`/teams/edit/${team.id}`)"
            >
              <PencilIcon class="h-5 w-5" />
            </BaseButton>
            <BaseButton
              class="p-2 rounded-full"
              variant="delete"
              tooltip="Delete team"
              @click="askDelete(team.id)"
            >
              <TrashIcon class="h-5 w-5" />
            </BaseButton>
          </div>
        </div>
      </li>
    </ul>

    <p v-if="teams.length === 0" class="text-gray-500 mt-4 text-center">No teams found.</p>

    <ConfirmModal
      :isOpen="showDeleteModal"
      title="Delete Team"
      message="Are you sure you want to delete this team?"
      @confirm="confirmDelete"
      @cancel="showDeleteModal = false"
    />
  </div>
</template>

<script>
import BaseButton from "@/BaseComponents/BaseButton.vue";
import BaseInfoIcon from "@/BaseComponents/BaseInfoIcon.vue";
import ConfirmModal from "@/BaseComponents/ConfirmModal.vue";
import { PencilIcon, TrashIcon } from "@heroicons/vue/24/solid";
import { ERKLAERUNG } from "@/async-sessions/erklaerungen";

import { getTeams, deleteTeam } from "@/live-sessions/api/teams";

export default {
  components: {
    BaseButton,
    BaseInfoIcon,
    ConfirmModal,
    PencilIcon,
    TrashIcon,
  },

  data() {
    return {
      ERKLAERUNG,
      teams: [],
      showDeleteModal: false,
      teamToDelete: null,
    };
  },

  methods: {
    async fetchTeams() {
      const res = await getTeams();
      this.teams = res.data.sort((a, b) => a.name.localeCompare(b.name));
    },

    askDelete(teamId) {
      this.teamToDelete = teamId;
      this.showDeleteModal = true;
    },

    async confirmDelete() {
      if (!this.teamToDelete) return;
      await deleteTeam(this.teamToDelete);
      this.showDeleteModal = false;
      this.teamToDelete = null;
      await this.fetchTeams();
    },
  },

  async mounted() {
    await this.fetchTeams();
  },
};
</script>
